/* eslint-disable no-unused-vars */
const Autodesk = window.Autodesk;
import store from '@/store';

class TouchSelectionExtension extends Autodesk.Viewing.Extension {
    constructor(loadedViewer, options) {
        super(loadedViewer, options);
        this.viewer = loadedViewer;
        var webGLDOM = this.viewer.canvas.parentElement.parentElement.parentElement;
        webGLDOM.addEventListener("click", (event) => {
            this.onMouseUp(event);
        });
        this.viewer.canvas.addEventListener("mousedown",(event)=>{
            this.onMouseDown(event);
        });
        webGLDOM.addEventListener("mousemove",(event)=>{
            this.onMouseMove(event);
        },false);

        this.selectionDbidsList = [];
    }
    load() {

        return true;
    }
    resetSelectionList() {
        this.selectionDbidsList = this.viewer.model.selector.getSelection();
    }
    onMouseMove(mouse) {
        if (!this||!this.dragged) {
            this.dragged = true;
            return;
        }
    }
    onMouseDown(mouse) {
        if (mouse.which != 1)
            return;
        if (!this)
            return;
        this.dragged = false;
    }
    onMouseUp(event) {
        if (event.which != 1)
            return;
        if (!this || this.dragged)
            return;

        if (!store.state.addRemove3dModeEnabled)
            return;
        var renderer = this.viewer.impl.renderer();
        var viewport = this.viewer.impl.clientToViewport(event.screenX, event.screenY);
        var dbId = renderer.idAtPixel(viewport.x, viewport.y);
        if (dbId < 0)
            return;
        if (this.selectionDbidsList.includes(dbId)) {
            var index = this.selectionDbidsList.findIndex(o => o == dbId);
            this.selectionDbidsList.splice(index, 1);
        } else
            this.selectionDbidsList.push(dbId);
        this.viewer.select(this.selectionDbidsList);
    }

}
Autodesk.Viewing.theExtensionManager.registerExtension('TouchSelectionExtension', TouchSelectionExtension);